import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { MessageCircle, Handshake, TrendingUp } from 'lucide-react';
export function BondSection() {
  const shifts = [{
    icon: MessageCircle,
    before: '"Get off your phone."',
    after: '"How did the meeting with the coffee shop go?"',
    description: 'Lectures turn into strategy sessions. You become their sounding board — not their warden.'
  }, {
    icon: Handshake,
    before: 'Nagging about "wasted potential"',
    after: 'Collaborating on a real business challenge',
    description: 'When you hand them real responsibility, you signal something powerful: "I trust you." That changes everything.'
  }, {
    icon: TrendingUp,
    before: 'Worrying about their future',
    after: 'Watching them build one',
    description: "There's nothing quite like seeing your teenager negotiate a deal, solve a client's problem, or deposit their first earned check."
  }];
  return <section className="bg-brand-cream py-24 px-6" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <p className="text-brand-teal font-bold text-sm tracking-widest uppercase text-center mb-4" data-id="element-36">
            Beyond the Income
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 leading-tight" data-id="element-37">
            This Isn't Just a Side Hustle.
            <br data-id="element-38" />
            It's a New Way to Connect.
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-39">
          <p className="text-lg md:text-xl text-brand-gray text-center leading-relaxed mb-16 max-w-2xl mx-auto" data-id="element-40">
            When you stop treating your teenager like a problem to manage and
            start treating them like a professional with real skills, the
            relationship shifts. The eye-rolls fade. The dinner table
            conversations change.
          </p>
        </FadeIn>

        <div className="space-y-8" data-id="element-41">
          {shifts.map((shift, index) => {
          const Icon = shift.icon;
          return <FadeIn key={index} delay={index * 0.15} data-id="element-42">
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-brand-navy/5" data-id="element-43">
                  <div className="flex items-start gap-6" data-id="element-44">
                    <div className="flex-shrink-0 w-12 h-12 bg-brand-navy rounded-xl flex items-center justify-center" data-id="element-45">
                      <Icon className="w-6 h-6 text-brand-teal" data-id="element-46" />
                    </div>
                    <div className="flex-1" data-id="element-47">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-3" data-id="element-48">
                        <span className="text-red-400/80 line-through text-base italic" data-id="element-49">
                          {shift.before}
                        </span>
                        <span className="hidden sm:inline text-brand-teal font-bold" data-id="element-50">
                          →
                        </span>
                        <span className="text-brand-navy font-bold text-lg" data-id="element-51">
                          {shift.after}
                        </span>
                      </div>
                      <p className="text-brand-gray leading-relaxed text-lg" data-id="element-52">
                        {shift.description}
                      </p>
                    </div>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.5} data-id="element-53">
          <div className="mt-14 text-center" data-id="element-54">
            <p className="text-xl md:text-2xl text-brand-navy font-heading font-bold leading-relaxed italic" data-id="element-55">
              "You're not hiring a teenager to do chores.
              <br className="hidden md:block" data-id="element-56" /> You're partnering with a young
              professional to build something real."
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.65} data-id="element-57">
          <div className="mt-10 bg-brand-navy/5 rounded-2xl p-8 text-center" data-id="element-58">
            <p className="text-lg text-brand-gray leading-relaxed" data-id="element-59">
              We built this guide because we believe the best memories aren't
              made <em data-id="element-60">despite</em> the screen — they're made when families use
              it <strong className="text-brand-navy" data-id="element-61">together</strong>, on
              something that matters. This is the first edition, and it's just
              the beginning.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}